export const CREDENTIAL_OTHER = "OTHER";

export const CERTIFICATION_CATALOG = [
  { code: "HOME_CARE_AIDE", name: "Home Care Aide Certification" },
  {
    code: "NURSING_ASSISTANT_CERTIFIED",
    name: "Nursing Assistant Certified (NAC)",
  },
  { code: "CPR", name: "CPR" },
  { code: "FIRST_AID", name: "First Aid" },
  { code: "HIV_AIDS_TRAINING", name: "HIV/AIDS Training (7-Hour)" },
  { code: "FOOD_HANDLER", name: "Food Handler Card" },
  { code: "NURSE_DELEGATION", name: "Nurse Delegation Core Training" },
  { code: "DEMENTIA_SPECIALTY", name: "Dementia Specialty Training" },
  { code: "MENTAL_HEALTH_SPECIALTY", name: "Mental Health Specialty Training" },
  {
    code: "DD_SPECIALTY",
    name: "Developmental Disabilities Specialty Training",
  },
  { code: "BASIC_TRAINING", name: "Adult Family Home Basic Training" },
  {
    code: "NURSING_ASSISTANT_REGISTERED",
    name: "Nursing Assistant Registered (NA-R)",
  },
  {
    code: "DIABETES_SPECIAL_FOCUS",
    name: "Nurse Delegation Special Focus on Diabetes",
  },
{ code: "ADMINISTRATOR_TRAINING", name: "Adult Family Home Administrator Training (48-Hour)" },

];

export const LICENSE_CATALOG = [
  { code: "WA_RN", name: "Registered Nurse (RN) License - Washington" },
  { code: "WA_LPN", name: "Licensed Practical Nurse (LPN) License - Washington" },
  { code: "WA_ARNP", name: "Advanced Registered Nurse Practitioner License - Washington" },
  { code: "WA_PHYSICIAN_MD", name: "Physician (MD) License - Washington" },
  { code: "WA_PHYSICIAN_DO", name: "Osteopathic Physician (DO) License - Washington" },
  { code: "WA_PHYSICIAN_ASSISTANT", name: "Physician Assistant License - Washington" },
  { code: "WA_OSTEOPATHIC_PHYSICIAN_ASSISTANT", name: "Osteopathic Physician Assistant License – Washington" },
];

export const catalogFor = (section) =>
  section === "licenses" ? LICENSE_CATALOG : CERTIFICATION_CATALOG;

const key = (v) =>
  String(v || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

/** Existing records have no code: match their saved name to the catalog, else treat as OTHER. */
export const resolveCredentialCode = (section, item) => {
  if (item?.credentialCode) return item.credentialCode;
  if (!key(item?.name)) return undefined;
  return (
    catalogFor(section).find((e) => key(e.name) === key(item.name))?.code ||
    CREDENTIAL_OTHER
  );
};

/** The catalog name always wins over anything typed. */
export const applyCatalogName = (section, values) => {
  const entry = catalogFor(section).find(
    (e) => e.code === values?.credentialCode,
  );
  return entry ? { ...values, name: entry.name } : values;
};
